import Section from "../../modules/section/Section";
import ServicesIconList from "../../modules/servicesIconList/ServicesIconList";

const Services = () => {
  return (
    <Section twoColumn container>
      <ServicesIconList servicesPage/>
    </Section>
  );
}

export default Services;